//Reset data
export const RESET = "MOTIF_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "MOTIF_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "MOTIF_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "MOTIF_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "MOTIF_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "MOTIF_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "MOTIF_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "MOTIF_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "MOTIF_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "MOTIF_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "MOTIF_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "MOTIF_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "MOTIF_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "MOTIF_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "MOTIF_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "MOTIF_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "MOTIF_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "MOTIF_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "MOTIF_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "MOTIF_SHOW_SET_MODAL_TYPE"